module.exports = __webpack_public_path__ + "static/media/tenantloan.53c69a4e.png";